import styled from "styled-components"

export const IndexTemplateContainer = styled.div``
